import { render, staticRenderFns } from "./BirthDateInput.vue?vue&type=template&id=f2fdf36a"
import script from "./BirthDateInput.vue?vue&type=script&lang=js"
export * from "./BirthDateInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports